
import {defineComponent} from 'vue';
import organisatiesQuery from '~/graphql/queries/organisaties.gql';
import gemeentes from '~/mixins/gemeentes';
import {defaultPagination} from '~/utils/graphql';
import {Organisatie} from '~/graphql/graphql';

export default defineComponent({
  mixins: [gemeentes],
  auth: false,

  apollo: {
    organisaties: {
      query: organisatiesQuery,
      debounce: 100,
      variables() {
        return {
          limit: 18,
          query: this.query,
          page: this.page,
          starts_with: this.currentLetter,
          ...(this.filters || {}),
        };
      },
    },
  },

  data: () => ({
    filterOverlay: false,
    page: 1,
    filters: {},
    organisaties: defaultPagination<Organisatie>(),
    currentLetter: '',
    query: '',
  }),

  head() {
    return {
      title: 'Organisaties',
    };
  },

  methods: {
    searchOrg(query: string) {
      this.query = query;
    },
  },
});
